import React, { useState, useEffect } from 'react';
import hamiltonWaitGif from '../assets/Q6/hamilton-wait.gif';
import hamiltonWaitForItGif from '../assets/Q6/hamilton-wait-for-it.gif';

function Q6({ question = 6, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [countdown, setCountdown] = useState(null);
  const isCounting = countdown !== null && countdown > 0;
  const gifSrc = isCounting ? hamiltonWaitForItGif : hamiltonWaitGif;
  const buttonText = isCounting ? String(countdown) : "I'm willing to wait for it!";

  useEffect(() => {
    if (countdown === null || countdown <= 0) return;
    const id = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          onNavigate?.('q7');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [countdown, onNavigate]);

  const handleClick = () => {
    if (countdown === null) {
      setCountdown(5);
    }
  };

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I am an original title</span>
        <h1>Project Valen</h1>
        <p>Wait for it...</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center q6__center">
      <span className="secretpin__title q2__greeting q6__greeting">Wait for it...</span>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q2__wave-button q6__button"
        onClick={handleClick}
        disabled={isCounting}
      >
        {buttonText}
      </button>
      <img src={gifSrc} alt="" className="q2__gif q6__gif" />
    </div>
  </div>
  );
}

export default Q6;
